// extracted by mini-css-extract-plugin
export default {"header":"style--header--f64cad"};